import { z } from "zod/v4";
import { FaqArticleDbParser_, FaqCollectionDbParser_ } from "./faq-db-parser";

const faqThemeBodySchema_ = z.object({
  brandKitOverrides: z.object({ pageBackgroundColor: z.boolean() }),
  homeBackgroundImageUrl: z.string().nullish(),
  overlayColor: z.string(),
  overlayOpacity: z.number(),
  headlineText: z.string(),
  headlineTextColor: z.string(),
  pageBackgroundColor: z.string(),
  displayCollectionIcon: z.boolean(),
  displayCollectionSubtext: z.boolean(),
  collectionBackgroundColor: z.string(),
  collectionBorderColor: z.string(),
  collectionCornerRadius: z.number(),
});
export const faqThemeBodySchema: z.ZodType<IFaqTheme> = faqThemeBodySchema_;
export interface IFaqTheme extends z.infer<typeof faqThemeBodySchema_> {}

export function defaultFaqTheme(): IFaqTheme {
  return {
    brandKitOverrides: { pageBackgroundColor: false },
    overlayColor: "#ffffff",
    overlayOpacity: 0,
    headlineText: "Help center",
    headlineTextColor: "#141414",
    pageBackgroundColor: "#fafafa",
    displayCollectionIcon: false,
    displayCollectionSubtext: true,
    collectionBackgroundColor: "#ffffff",
    collectionBorderColor: "#d6d6d6",
    collectionCornerRadius: 8,
  };
}

const faqCollectionBodySchema_ = FaqCollectionDbParser_.extend({
  _id: z.string(),
  team: z.string(),
  articles: z.array(z.string()),
});
export const faqCollectionBodySchema: z.ZodType<FaqCollection> =
  faqCollectionBodySchema_;
export interface FaqCollection
  extends z.infer<typeof faqCollectionBodySchema_> {}

export const faqArticleBodySchema_ = FaqArticleDbParser_.extend({
  _id: z.string(),
  team: z.string(),
  faqCollection: z.string(),
});
export const faqArticleBodySchema: z.ZodType<FaqArticle> =
  faqArticleBodySchema_;
export interface FaqArticle extends z.infer<typeof faqArticleBodySchema_> {}
